import { render, staticRenderFns } from "./BoutList.vue?vue&type=template&id=6c444a1e&"
import script from "./BoutList.vue?vue&type=script&lang=js&"
export * from "./BoutList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports